import app from 'flarum/forum/app';
import Model from 'flarum/common/Model';
import Badge from 'flarum/common/components/Badge';
import User from 'flarum/common/models/User';
import ItemList from 'flarum/common/utils/ItemList';
import Form from './Form';
import {SubmissionPayload} from './JsonTypes';

export default class Submission extends Model {
    formData = Model.attribute<SubmissionPayload | null>('data'); // Can't call it data because it's used internally
    isLocked = Model.attribute<boolean>('isLocked');
    isHidden = Model.attribute<boolean>('isHidden');
    createdAt = Model.attribute<string>('createdAt');

    user = Model.hasOne<User>('user');
    form = Model.hasOne<Form>('form');

    badges() {
        const items = new ItemList();

        if (this.isLocked()) {
            items.add('lock', Badge.component({
                type: 'lock',
                icon: 'fas fa-lock',
                label: app.translator.trans('kilowhat-formulaire.forum.badge.locked'),
            }));
        }

        if (this.isHidden()) {
            items.add('hidden', Badge.component({
                type: 'hidden',
                icon: 'fas fa-trash',
                label: app.translator.trans('kilowhat-formulaire.forum.badge.hidden'),
            }));
        }

        return items;
    }

    apiEndpoint() {
        return '/formulaire/submissions' + (this.exists ? '/' + (this.data as any).id : '');
    }
}
